import { useMemo } from 'react'

export const useHighlightedText = (text?: string, highlighted?: string) =>
  useMemo(() => {
    if (!text) {
      return { before: '', highlight: '', after: '' }
    }

    if (!highlighted || !text.includes(highlighted)) {
      return { before: text, highlight: '', after: '' }
    }

    const startIndex = text.indexOf(highlighted)
    const endIndex = startIndex + highlighted.length

    return {
      before: text.slice(0, startIndex),
      highlight: text.slice(startIndex, endIndex),
      after: text.slice(endIndex),
    }
  }, [text, highlighted])
